"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accessor_1 = require("../../models/Accessor");
var relativeToDateRangeWindow_1 = require("./relativeToDateRangeWindow");
var engine_1 = require("../../engine");
var dateUtils_1 = require("../../dateUtils");
var comparisonEngine_1 = require("../comparison/comparisonEngine");
var integration_1 = require("./integration");
var core_1 = require("./core");
var ComparisonSpecType_1 = require("../../models/ComparisonSpecType");
exports.getWindowDateRange = function (window, table, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultTimestampAccessor; }
    switch (window.type) {
        case core_1.DateWindowTypes.CUSTOM:
            return window.range;
        case core_1.DateWindowTypes.LATEST_DATA:
            return relativeToDateRangeWindow_1.relativeToDateRangeWindow(table, window.duration, accessor);
        case core_1.DateWindowTypes.DEFINED_START:
            var latestRow = engine_1.getLatestValue(table);
            if (!latestRow) {
                return undefined;
            }
            var last = accessor(latestRow);
            if (!last) {
                return undefined;
            }
            return { first: window.startDate, last: last };
        case core_1.DateWindowTypes.LAST_N:
        case core_1.DateWindowTypes.SPECIAL:
        default:
            var windowedMetric = integration_1.applyWindow(table, window, accessor);
            return dateUtils_1.getDateRange(windowedMetric, accessor);
    }
};
exports.getWindowDateRangeForComparison = function (dateWindow, table, comparison) {
    var _a;
    if (table.length === 0) {
        return undefined;
    }
    var windowDateRange = exports.getWindowDateRange(dateWindow, table);
    if (windowDateRange && comparison && ComparisonSpecType_1.isHistoricalComparisonSpec(comparison)) {
        var comparisonRange = comparisonEngine_1.rangeBefore(windowDateRange, (_a = comparison.numberOfPeriods, (_a !== null && _a !== void 0 ? _a : 1)), comparison.comparisonPeriod);
        return comparisonRange;
    }
    return undefined;
};
//# sourceMappingURL=getWindowDateRange.js.map